<main id="main-heading" tabindex="0" class="container-fluid" [@fadeInOut] role="main">
  <div class="col-sm-11 mx-auto main-heading-div d-flex flex-column">
    <div class="row mt-3">
      <div class="col-sm-12">
        <h1 tabindex="0">Need Help?</h1>
        <p tabindex="0"
           aria-label="If you're having trouble with tasks like ingesting a file, passing validation for a device or creating submission items, please contact our helpdesk at +1 877-888-1559 (toll free) or email us anytime at SSMD@reedtech.com.">
          If you're having trouble with tasks like ingesting a file, passing validation for a device or creating
          submission items, please contact our helpdesk at <strong>+1 877-888-1559</strong>(toll free) or email us anytime at
          <a href="mailto:SSMD@reedtech.com" role="button"
             aria-label="SSMD@reedtech.com">SSMD&#64;reedtech.com</a>.
        </p>
        <p class="mt-3 title-div">
          <a href="../../../assets/documents/reedTechSingleSourceUserGuide.docx" role="button"
             aria-label="Download user guide (docx)">Download user guide (docx)</a>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-10">
        <hr>
      </div>
    </div>
  </div>
</main> <!--  End Container -->
<p>&nbsp;</p>
<div class="cleared"></div>
<!-- end table -->

<div class="bottom-padding"></div>
